import * as z from "zod";

export const SUGGEST_TEXT_MAX_LENGTH = 2000;
export const SUGGEST_PREFIX_MIN_LENGTH = 2;
export const SUGGEST_PREFIX_MAX_LENGTH = 32;

// The only English words shorter than SUGGEST_PREFIX_MIN_LENGTH, so a client
// can settle them without asking a route that refuses one-letter prefixes.
export const ONE_LETTER_WORDS: ReadonlySet<string> = new Set(["a", "i"]);

export const suggestRequestSchema = z.object({
  text: z.string().max(SUGGEST_TEXT_MAX_LENGTH),
  prefix: z
    .string()
    .min(SUGGEST_PREFIX_MIN_LENGTH)
    .max(SUGGEST_PREFIX_MAX_LENGTH)
    .regex(/^[a-z']+$/),
});
export type SuggestRequest = z.infer<typeof suggestRequestSchema>;

export const suggestResponseSchema = z.object({
  suggestion: z.string().nullable(),
  isWord: z.boolean(),
});
export type SuggestResponse = z.infer<typeof suggestResponseSchema>;
